/**
 * Message Type Constants
 *
 * Defines the different types of messages that can be sent in conversations
 */
export const MessageType = {
  /**
   * Plain text message
   */
  TEXT: 1,

  /**
   * Image message with uploaded image reference
   */
  IMAGE: 2,

  /**
   * File attachment message (future implementation)
   */
  FILE: 3,

  /**
   * Voice message (future implementation)
   */
  VOICE: 4
};
